import React from 'react'

function SettingsForms() {
    const [showPersonalInforForms, setshowPersonalInforForms] = React.useState(true)
    const [showPrivacyandSecurity, setshowPrivacyandSecurity] = React.useState(true)
    const [selectedItem, setSelectedItem] = React.useState(0)

    React.useEffect(() => {
        if (selectedItem == 0) {
            setshowPersonalInforForms(true)
            setshowPrivacyandSecurity(false)
        } else {
            setshowPersonalInforForms(false)
            setshowPrivacyandSecurity(true)
        }
    })

    const tabItems = ["Personal Information", "Privacy & Security"]
    return (
        <main>
            <div className="">
                <div className="mt-5">
                    <div className="">
                        <ul role="tablist" className="max-w-screen-xl mx-auto border-b flex items-center gap-x-3 overflow-x-auto text-sm">
                            {
                                tabItems.map((item, idx) => (
                                    <li key={idx} className={`py-2 border-b-2 ${selectedItem == idx ? "border-red-600 text-red-600" : "border-white text-gray-500"}`}>
                                        <button
                                            role="tab"
                                            aria-selected={selectedItem == idx ? true : false}
                                            aria-controls={`tabpanel-${idx + 1}`}
                                            className="py-2.5 pr-4 rounded-lg duration-150 hover:text-red-600 hover:bg-gray-50 active:bg-gray-100 font-medium"
                                            onClick={() => setSelectedItem(idx)}
                                        >
                                            {item}
                                        </button>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>


                    {/* personal information */}

                    {
                        showPersonalInforForms &&

                        <div>
                            <div className="mt-6">
                                <p className="text-base font-bold text-gray-900">Personal Information</p>
                                <p className="mt-1 text-sm font-medium text-gray-500">Edit and update your personal information.</p>
                            </div>

                            <form action="#" method="POST" className="max-w-3xl mt-12 accountForms">
                                <div className="space-y-8">
                                    <div className="sm:grid sm:grid-cols-3 sm:gap-5 sm:items-start">
                                        <label htmlFor="fullname" className="block text-sm font-bold text-gray-900 sm:mt-px sm:pt-2">Fullname</label>
                                        <div className="mt-2 sm:mt-0 sm:col-span-2">
                                            <input type="text" name="fullname" id="text" placeholder="" defaultValue="Fullname" className="border block w-full px-4 py-3 placeholder-gray-500 border-gray-300 rounded-lg focus:ring-indigo-600 focus:border-indigo-600 sm:text-sm caret-indigo-600" />
                                        </div>
                                    </div>

                                    <div className="sm:grid sm:grid-cols-3 sm:gap-5 sm:items-start">
                                        <label htmlFor="country" className="block text-sm font-bold text-gray-900 sm:mt-px sm:pt-2">Country of Residence</label>
                                        <div className="mt-2 sm:mt-0 sm:col-span-2">
                                            <select id="country" className="block w-full py-3 pl-4 pr-10 border-gray-300 rounded-lg focus:outline-none focus:ring-indigo-600 focus:border-indigo-600 sm:text-sm">
                                                <option>United States</option>
                                            </select>
                                        </div>
                                    </div>

                                </div>

                                <div className="mt-6 sm:mt-12">
                                    <button
                                        type="button"
                                        className="inline-flex items-center justify-center w-full px-4 py-3 text-sm font-semibold leading-5 text-white transition-all duration-200 bg-red-600 border 
                                    border-transparent rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-600 hover:bg-red-500"
                                    >
                                        <h5 className='upgradeNowText'>
                                            Save Changes
                                        </h5>
                                    </button>
                                </div>
                            </form>
                        </div>

                        ||


                        <form action="#" method="POST" className="max-w-3xl mt-12 accountForms">
                            <div className="space-y-8">
                                <div className="sm:grid sm:grid-cols-3 sm:gap-5 sm:items-start">
                                    <label htmlFor="email" className="block text-sm font-bold text-gray-900 sm:mt-px sm:pt-2">Email Address</label>
                                    <div className="mt-2 sm:mt-0 sm:col-span-2">
                                        <input type="email" name="email" id="text" placeholder="" defaultValue="email@dddddd.com" className="border block w-full px-4 py-3 placeholder-gray-500 border-gray-300 rounded-lg focus:ring-indigo-600 focus:border-indigo-600 sm:text-sm caret-indigo-600" />
                                    </div>
                                </div>

                                <div className="sm:grid sm:grid-cols-3 sm:gap-5 sm:items-start">
                                    <label htmlFor="fullname" className="block text-sm font-bold text-gray-900 sm:mt-px sm:pt-2">Enter Old Password</label>
                                    <div className="mt-2 sm:mt-0 sm:col-span-2">
                                        <input type="password" name="oldpassword" id="text" placeholder="" defaultValue="" className="border block w-full px-4 py-3 placeholder-gray-500 border-gray-300 rounded-lg focus:ring-indigo-600 focus:border-indigo-600 sm:text-sm caret-indigo-600" />
                                    </div>
                                </div>

                                <div className="sm:grid sm:grid-cols-3 sm:gap-5 sm:items-start">
                                    <label htmlFor="fullname" className="block text-sm font-bold text-gray-900 sm:mt-px sm:pt-2">New Password</label>
                                    <div className="mt-2 sm:mt-0 sm:col-span-2">
                                        <input type="password" name="newemail" id="text" placeholder="" defaultValue="" className="border block w-full px-4 py-3 placeholder-gray-500 border-gray-300 rounded-lg focus:ring-indigo-600 focus:border-indigo-600 sm:text-sm caret-indigo-600" />
                                    </div>
                                </div>

                            </div>

                            <div className="mt-6 sm:mt-12">
                                <button
                                    type="button"
                                    className="inline-flex items-center justify-center w-full px-4 py-3 text-sm font-semibold leading-5 text-white transition-all duration-200 bg-red-600 border 
                                    border-transparent rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-600 hover:bg-red-500"
                                >
                                    <h5 className='upgradeNowText'>
                                        Update Settings
                                    </h5>
                                </button>
                            </div>
                        </form>
                    }

                    {/* privacy and security */}
                </div>
            </div>
        </main>
    )
}

export default SettingsForms